<template>
  <div>
    <div class="header-width divcss5">
      <productdetailbanner></productdetailbanner>
    </div>
    <div class=" row body-width divcss5">
      <zncyheader></zncyheader>
    </div>
    <div class=" row body-width divcss5">
      <router-view />
    </div>
  </div>
</template>
<script>
  import productdetailbanner from "@/components//contentcoms/prodecutcontentcoms/productdetailbanner";
  import zncyheader from "@/components/contentcoms/prodecutcontentcoms/zncyxlcp/zncyheader";

  export default {
    name: "productzncy",
    components: {
      productdetailbanner,
      zncyheader,
    }
  }

</script>



// WEBPACK FOOTER //
// src/pages/productzncy.vue